<template>
  <div class="pl-16 pr-16 mr-10">
    <v-row class="pt-5">
      <v-col cols="12" offset="0">
        <v-row>
          <v-col cols="6"> <results-behaviour :id="id" /> </v-col>
          <v-col cols="6"> <results-dynamics :id="id" /> </v-col>
          <v-col cols="6"> <results-knowledge :id="id"/></v-col>
          <v-col cols="6"> <results-language :id="id"/></v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import lodash from "lodash";

import { mapState } from "vuex";

import ResultsBehaviour from "./ResultsBehaviour";
import ResultsDynamics from "./ResultsDynamics";
import ResultsKnowledge from "./ResultsKnowledge";
import ResultsLanguage from "./ResultsLanguage";

export default {
  name: "ResultsFourCornersSummary",
  data() {
    return {};
  },
  components: {
    ResultsBehaviour,
    ResultsDynamics,
    ResultsKnowledge,
    ResultsLanguage,
  },
  props: {
    uid: String,
    id: String,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {},
};
</script>
